"use client";

import type { CSSProperties } from "react";
import {
	ArtistIcon,
	EmptyState,
} from "@/components/design-system/ArtistDesignSystem";

const wrapStyle: CSSProperties = {
	paddingTop: 40,
};

/**
 * SignInRequiredState — empty state shown when an unauthenticated visitor
 * opens a sign-in-gated Library tab (作品 / 收藏 / 好听). Mirrors
 * `signInRequiredState` on iOS (`DSEmptyState` + title + message + primary
 * "Sign in" CTA). The 笔记 tab is intentionally excluded and stays offline.
 */
export function SignInRequiredState() {
	return (
		<div className="library-sign-in-required" style={wrapStyle}>
			<EmptyState
				title="登录后查看"
				message="登录后即可查看你的作品、收藏与好听。"
				symbol={<ArtistIcon name="person" size={36} />}
				actionLabel="登录"
				actionSymbol={<ArtistIcon name="person" size={16} />}
				onAction={() => window.location.assign("/auth")}
			/>
		</div>
	);
}
